<template>
   <ul class="design-image__list">
      <li v-for="(design,index) in designList" :key="index">
        <router-link :to="`/design_detail?id=${design.designID}`">
          <img v-lazy="design.designImg">
          <div class="design-image__list__text design-image__list__name">
            <span>NAME</span>
            <span>|</span>
            <span>项目名称</span>
            <span>{{design.designName||'未知'}}</span>
          </div>
          <div class="design-image__list__text design-image__list__time">
            <span>TIME</span>
            <span>|</span>
            <span>项目时间</span>
            <span>{{dayFormat(design.designTime)}}</span>
          </div>
          <div class="masking"></div>
        </router-link> 
      </li>
    </ul>
</template>

<script>
import Vue from 'vue';
import dayjs from 'dayjs'
export default Vue.extend({
  name:'Design',
  data () {
     return {
        designList: [
        ]
      } 
  },
  created(){
    this.getList();
  },
  methods:{
    getList() {
      this.$https.get("/api/design/getListForweb").then((res) => {
        this.designList = res.data.items;
      });
    },
    dayFormat(time){
      return dayjs(time).format('YYYY.MM.DD')
    },
  }
})
</script>